export default __webpack_public_path__ + "static/media/6.9d17ed67.jpg";